// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F9JFG","name":"styles_name__1GSLG","phone":"styles_phone__1kb6e"};